(function ($) {
    $(document).on('ready', function () {
        gsap.registerPlugin(Flip);
        viewMoreLess();
        flipFiltersApartments();
        flipFiltersDestinations();
        pinFilters();
    });

    function viewMoreLess() {
        const galleryNoFilter = $('.gallery_section.grid.no_filtered');
        const wrap = galleryNoFilter.find('.slider_inner_wrap');
        const viewMore = galleryNoFilter.find('#open_view');
        const viewLess = galleryNoFilter.find('#close_view');
        if (globalVar.is_desktop) {
            if (galleryNoFilter.length !== 0 && wrap.length !== 0) {
                let items = wrap.children();

                if (items.length > 5) {
                    let bigItem = wrap.children().first();
                    let heightWrap = wrap.outerHeight(true);
                    let heightBigItem = bigItem.outerHeight(true);
                    wrap.css('height', heightBigItem);
                    viewMore.on('click', function () {
                        //wrap.css('height', heightWrap);
                        wrap.css({'height': heightWrap})
                        $('#open_view').hide();
                        $('#close_view').show();
                    });

                    viewLess.on('click', function () {
                        wrap.css({'height': heightBigItem});
                        $('#open_view').show();
                        $('#close_view').hide();
                    });
                }
            }
        } else {
            if (wrap !== 0) {
                let items = wrap.children();

                if (items.length > 5) {
                    let firstItem = wrap.children().first();
                    let secondItem = wrap.children().eq(2);
                    let fourthItem = wrap.children().eq(4);
                    let heightWrap = wrap.outerHeight(true);
                    let heightFirstItem = firstItem.outerHeight(true);
                    let heightSecondItem = secondItem.outerHeight(true);
                    let heightFourthItem = fourthItem.outerHeight(true);

                    let totalHeight = heightFirstItem + heightSecondItem + heightFourthItem;
                    wrap.css('height', totalHeight);
                    viewMore.on('click', function () {
                        //wrap.css('height', heightWrap);
                        wrap.animate({height: heightWrap}, 500)
                        $('#open_view').hide();
                        $('#close_view').show();
                    });

                    viewLess.on('click', function () {
                        wrap.animate({height: totalHeight}, 500);
                        $('#open_view').show();
                        $('#close_view').hide();
                    });
                }
            }
        }
    }

    function flipFiltersApartments() {
        const galleryFilter = $('.gallery_section.grid.filtered');
        const wrap = galleryFilter.find('.slider_inner_wrap');
        if (galleryFilter.length !== 0 && wrap.length !== 0) {
            if (globalVar.is_desktop) {
                const allCheckbox = document.querySelector('#gallery_filter_desktop #all_apartments'),
                    filters = gsap.utils.toArray('#gallery_categories_wrap .filter'),
                    items = gsap.utils.toArray('.thumb_wrap');

                function updateFilters() {
                    const state = Flip.getState(items), // get the current state
                        classes = filters.filter(checkbox => checkbox.checked).map(checkbox => "." + checkbox.id),
                        matches = classes.length ? gsap.utils.toArray(classes.join(",")) : classes;

                    // adjust the display property of each item ("none" for filtered ones, "block" for matching ones)
                    items.forEach(item => item.style.display = matches.indexOf(item) === -1 ? "none" : "block");

                    // animate from the previous state
                    Flip.from(state, {
                        duration: 1,
                        scale: true,
                        absolute: true,
                        ease: "power3.inOut",
                        onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {
                            opacity: 1,
                            scale: 1,
                            duration: 1
                        }),
                        onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: 1})
                    });

                    // Update the All checkbox:
                    allCheckbox.checked = matches.length === items.length;
                    allCheckbox.checked ? allCheckbox.parentNode.classList.add('active') : allCheckbox.parentNode.classList.remove('active');

                    //Update other checkboxes
                    filters.forEach((btn) => {
                        btn.checked ? btn.parentNode.classList.add('active') : btn.parentNode.classList.remove('active');
                    });
                }

                filters.forEach(btn => btn.addEventListener('click', updateFilters));
                allCheckbox.addEventListener('click', () => {
                    filters.forEach(checkbox => checkbox.checked = allCheckbox.checked);
                    updateFilters();
                });
            } else {
                //Select2 multi-choice
                var select2Multiple = $('#select_apartments');
                if (select2Multiple.length) {
                    const items = gsap.utils.toArray('.thumb_wrap');
                    const filters = gsap.utils.toArray('#select_apartments .filter-select');

                    select2Multiple.on('change', function () {
                        var value = $(this).val() ? $(this).val() : '';
                        // console.log(value)
                        // Get filter value from option value
                        loadFilterSelect(value)
                    });

                    function loadFilterSelect(value) {
                        const state = Flip.getState(items); // get the current state
                        const matches = value.length ? gsap.utils.toArray(value.join(",")) : gsap.utils.toArray(filters.map(filterItem => filterItem.id).join(","));
                        //console.log(matches)
                        // console.log(value)
                        // adjust the display property of each item ("none" for filtered ones, "block" for matching ones)
                        items.forEach(item => item.style.display = matches.indexOf(item) === -1 ? "none" : "block");

                        // animate from the previous state
                        // No duration when onLeave to avoid showing when the block goes out
                        Flip.from(state, {
                            duration: 0.5,
                            scale: true,
                            absolute: true,
                            ease: "power3.inOut",
                            onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {
                                opacity: 1,
                                scale: 1,
                                duration: 0.5
                            }),
                            onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: 0})
                        });
                    }

                    select2Multiple.select2({
                        tags: true
                    });
                }
            }
        }
    }

    function flipFiltersDestinations() {
        const allCheckbox = document.querySelector('#gallery_filter_desktop #all_destinations'),
            filters = gsap.utils.toArray('#gallery_places_wrap .filter'),
            items = gsap.utils.toArray('.thumb_wrap');

        if (globalVar.is_desktop && $('#gallery_filter_desktop').length !== 0) {
            function updateFilters() {
                const state = Flip.getState(items), // get the current state
                    classes = filters.filter(checkbox => checkbox.checked).map(checkbox => "." + checkbox.id),
                    matches = classes.length ? gsap.utils.toArray(classes.join(",")) : classes;

                // adjust the display property of each item ("none" for filtered ones, "block" for matching ones)
                items.forEach(item => item.style.display = matches.indexOf(item) === -1 ? "none" : "block");


                // animate from the previous state
                Flip.from(state, {
                    duration: 1,
                    scale: true,
                    absolute: true,
                    ease: "power3.inOut",
                    onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {
                        opacity: 1,
                        scale: 1,
                        duration: 1
                    }),
                    onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: 1})
                });

                // Update the All checkbox:
                allCheckbox.checked = matches.length === items.length;
                allCheckbox.checked ? allCheckbox.parentNode.classList.add('active') : allCheckbox.parentNode.classList.remove('active');

                //Update other checkboxes
                filters.forEach((btn) => {
                    btn.checked ? btn.parentNode.classList.add('active') : btn.parentNode.classList.remove('active');
                });
            }

            filters.forEach(btn => btn.addEventListener('click', updateFilters));
            allCheckbox.addEventListener('click', () => {
                filters.forEach(checkbox => checkbox.checked = allCheckbox.checked);
                updateFilters();
            });
        } else {
            //Select2 multi-choice
            var select2Multiple = $('#select_destinations');
            if (select2Multiple.length) {
                const items = gsap.utils.toArray('.thumb_wrap');
                const filters = gsap.utils.toArray('#select_destinations .filter-select');

                select2Multiple.on('change', function () {
                    var value = $(this).val() ? $(this).val() : '';
                    // console.log(value)
                    // Get filter value from option value
                    loadFilterSelect(value)
                });

                function loadFilterSelect(value) {
                    const state = Flip.getState(items); // get the current state
                    const matches = value.length ? gsap.utils.toArray(value.join(",")) : gsap.utils.toArray(filters.map(filterItem => filterItem.id).join(","));
                    //console.log(matches)
                    // console.log(value)
                    // adjust the display property of each item ("none" for filtered ones, "block" for matching ones)
                    items.forEach(item => item.style.display = matches.indexOf(item) === -1 ? "none" : "block");

                    // animate from the previous state
                    // No duration when onLeave to avoid showing when the block goes out
                    Flip.from(state, {
                        duration: 0.5,
                        scale: true,
                        absolute: true,
                        ease: "power3.inOut",
                        onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {
                            opacity: 1,
                            scale: 1,
                            duration: 0.5
                        }),
                        onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: 0})
                    });
                }

                select2Multiple.select2({
                    tags: true
                });
            }
        }
    }

    function pinFilters() {
        const filters = $('#gallery_filter_desktop');
        if (filters !== 0 && globalVar.is_desktop) {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: filters,
                    start: "top 20%",
                    end: "bottom 80%",
                    scrub: true,
                    pin: true
                },
            });
        }
    }

}(jQuery));
